import { getPushCategoryEventHandler } from './AnalyticsGAHelpers';

const CATEGORY = 'onboarding_events';

enum Actions {
  VIEW_SLIDE = 'view_slide',
  CLOSE_SLIDE = 'close_slide',
  CLICK_PREV = 'click_prev',
  CLICK_NEXT = 'click_next',
}

const push = getPushCategoryEventHandler<Actions>(CATEGORY);

// Events

export function onboardingViewSlide(slideId: string) {
  push(Actions.VIEW_SLIDE, slideId);
}
export function onboardingCloseSlide(slideId: string) {
  push(Actions.CLOSE_SLIDE, slideId);
}

export function onboardingClickNext(slideId: string) {
  push(Actions.CLICK_NEXT, slideId);
}

export function onboardingClickPrev(slideId: string) {
  push(Actions.CLICK_PREV, slideId);
}
